import api from './_client';

export interface LoginPayload {
    email: string;
    password: string;
}

export interface ResetPasswordPayload {
    password: string;
}

export interface ResetPasswordTokenPayload {
    email: string;
}

export const login = (payload: LoginPayload) => api.post('/login', payload);

export const resetPasswordToken = (payload: ResetPasswordTokenPayload) => api.post('/resetToken', payload);

export const resetPassword = (payload: ResetPasswordPayload) => api.post('/reset', payload);

export const logout = () => api.post('/logout');

export const checkLoginStatus = () => api.get('/me');
